"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seats = void 0;
exports.seats = [
    {
        id: 1,
        name: '2',
        value: [2, 2],
    },
    {
        id: 2,
        name: '3-5',
        value: [3, 5],
    },
    {
        id: 3,
        name: '6-8',
        value: [6, 8],
    },
    {
        id: 4,
        name: '9-12',
        value: [9, 12],
    },
    {
        id: 5,
        name: '13-15',
        value: [13, 15],
    },
];
